import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { useAuthModal } from './Auth/AuthModal'

/**
 * Asks signed-out visitors to sign in right here; the page renders once they do, and
 * closing the modal sends them home. This only shapes the UI — the API enforces access
 * on every request regardless.
 */
const RequireAuth: React.FC<{ children: React.ReactElement }> = ({ children }) => {
  const isLoggedIn: boolean = useSelector((state: any) => state.user.isLoggedIn)
  const { openLogin } = useAuthModal()
  const navigate = useNavigate()

  useEffect(() => {
    if (!isLoggedIn) openLogin({ onDismiss: () => navigate('/', { replace: true }) })
  }, [isLoggedIn, openLogin, navigate])

  return isLoggedIn ? children : <div className="min-h-screen bg-gray-50 dark:bg-gray-950" />
}

export default RequireAuth
